import React from 'react';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { blobErrorMessage } from './utils';

/** `{ busy: {[key]: true}, exportSection(key) }` for the Export buttons in section headers. */
export const ExportContext = React.createContext(null);

export const useExcelDownloads = () => {
  const [busy, setBusy] = React.useState({});
  const download = React.useCallback(async (key, request, fallbackName = 'export.xlsx') => {
    setBusy(current => ({ ...current, [key]: true }));
    try {
      const { blob, filename } = await request();
      saveAs(blob, filename || fallbackName);
    } catch (error) {
      toast(await blobErrorMessage(error), { type: 'error' });
    } finally {
      setBusy(current => {
        const next = { ...current };
        delete next[key];
        return next;
      });
    }
  }, []);
  return { busy, download };
};
